export default `uniform float uTimeP;
uniform float uPixelRatio;
uniform float uSize;

attribute float aRotation;

varying float vAlpha;
varying float vRotation;

void main() {
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);

    
    modelPosition.y += sin(uTimeP * 0.5 + modelPosition.x * 0.1) * 0.4;
    modelPosition.x += cos(uTimeP * 0.3 + modelPosition.z * 0.1) * 0.4;
    modelPosition.z += sin(uTimeP * 0.4 + modelPosition.y * 0.1) * 0.4;

    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectionPosition = projectionMatrix * viewPosition;

    gl_Position = projectionPosition;

    
    gl_PointSize = uSize * uPixelRatio;
    gl_PointSize *= (1.0 / - viewPosition.z);

    vAlpha = smoothstep(-200.0, -10.0, viewPosition.z); 
    vRotation = aRotation;
}`